import React, {useState, useEffect} from "react"
import {useParams, useNavigate} from "react-router-dom";

import OrganizationApi from "../../services/organizations";
import CategoryApi from "../../services/categories";
import LocationApi from "../../services/locations";
import CountryApi from "../../services/countries";
import StateApi from "../../services/states";
import MunicipalityApi from "../../services/municipalities";
import OrganizationHeaderNav from "../../fragments/nav/OrganizationHeaderNav";
import OrganizationLocationHeaderNav from "../../fragments/nav/OrganizationLocationHeaderNav"
import CreateLocationForm from "../../forms/CreateLocationForm"
import Page from "../Page"
import Loading from "../../fragments/Loading"
import Error from "../../fragments/form/Error"
import Message from "../../fragments/form/Message"

const CreateOrganizationLocationPage = (props) => {
    const [error, setError] = useState();
    const [message, setMessage] = useState();
    const [organization, setOrganization] = useState();
    const [categories, setCategories] = useState();
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([])
    const [countryId, setCountryId] = useState(0);
    const [stateId, setStateId] = useState();

    const locationApi = new LocationApi(props.token);
    const organizationApi = new OrganizationApi(props.token);
    const categoryApi = new CategoryApi(props.token);
    const countryApi = new CountryApi(props.token);
    const stateApi = new StateApi(props.token);
    const municipalityApi = new MunicipalityApi(props.token);

    const routeParams = useParams();
    const { organizationId } = routeParams
    const navigate = useNavigate();

    useEffect(() => {
        organizationApi.getById(organizationId).then((response) => {
            setOrganization(response);
        })
        .catch((err) => {
            console.error(err.message, err.stack);
        });

        categoryApi.all().then((categories) => {
            setCategories(Object.values(categories));
        })
        .catch((err) => {
            console.error(err.message);
        });

    },[]);

    const handleSetCountryId=(id)=>{
        setCountryId(id)
    }

    const handleSetStateId=(id)=>{
        setStateId(id)
    }
    
    const handleSearchCountry =async(value)=>{
        try {
            if(value){
                let response = await countryApi.getCountryListByLetter(value)
                let arrCountry =  response.countries.map((e)=>({label: e.country , value: e.id,...e}))
                setCountries([...arrCountry])
            }else{
                setCountries([])
            }
        } catch (error) {
            console.error("Failed to fetch countries:", error);
        }
      
    }

    const handleSearchState =async(countryId, value)=>{
        try {
            if(value){
                let response = await stateApi.getStateListByLetter(countryId,value)
                let arrState=  response.states.map((e)=>({label: e.state , value: e.id,...e}))
                setStates([...arrState])
            }else{
                setStates([])
            }
        } catch (error) {
            console.error("Failed to fetch states:", error);
        }
      
    }

    const handleSearchCity = async (stateId, value)=>{
        try {
            if(value){
                let response = await municipalityApi.getCityListByLetter(stateId,value)
                let arrCity=  response.cities.map((e)=>({label: e.city , value: e.id,...e}))
                setCities([...arrCity])
            }else{
                setCities([])
            }
        } catch (error) {
            console.error("Failed to fetch cities:", error);
        }
    }

    const handleSearchLocation = (id, countryId, stateId, value)=>{
        if(id === 'country'){
            handleSearchCountry(value)
        }
        else if(id === 'state'){
            handleSearchState(countryId, value)
        }
        else if(id === 'city'){
            handleSearchCity(stateId, value)
        }else{
            //
        }
    }
    
    const onSubmit = (formData) => {
        if (formData.country_id === null || formData.state_id === null || formData.city_id === null) {
            delete formData.country_id;
            delete formData.state_id; 
            delete formData.city_id;
        }
        formData["organization_id"] = organizationId;
        locationApi.create(formData).then((response) => {
            if(routeParams.countryId && routeParams.stateId && routeParams.municipalityId && organizationId){
                navigate(`/country/${routeParams.countryId}/state/${routeParams.stateId}/municipality/${routeParams.municipalityId}/organization/${routeParams.organizationId}/location/${response.id}`)
            }else{
                navigate(`/organization/${organizationId}/location/${response.id}`);
            }
        })
        .catch((err) => {
            console.error(err.message, err.stack);
            const errorMessage = err.response?.data?.message || err.message;
            setError(errorMessage)
            setMessage("");
        });
    }

    const handleBack =()=>{
        if(routeParams.countryId && routeParams.stateId && routeParams.municipalityId && organizationId){
            return `/country/${routeParams.countryId}/state/${routeParams.stateId}/municipality/${routeParams.municipalityId}/organization/${routeParams.organizationId}/locations`
        }else{
            return `/organization/${organizationId}/locations`
        }
    }

    if(!organization || !categories) {
        return (<Loading />)
    }

    return (
        <Page 
            buttonText="Back"
            buttonUrl={handleBack()}
            header={`Creating location for organization: ${organization.name}`}
        >
            {routeParams.countryId && routeParams.stateId && routeParams.municipalityId && routeParams.organizationId ?
                <OrganizationLocationHeaderNav countryId={routeParams.countryId} stateId={routeParams.stateId} municipalityId={routeParams.municipalityId} organizationId={routeParams.organizationId} />
                :
                <OrganizationHeaderNav organizationId={organizationId} />
            }
            <Error message={error} />
            <Message message={message} />
            <CreateLocationForm
                organization={organization}
                categories={categories}
                countries={countries}
                states={states}
                cities={cities}
                countryId={countryId}
                stateId={stateId}
                handleSetCountryId={handleSetCountryId}
                handleSetStateId={handleSetStateId}
                handleSearchLocation={handleSearchLocation}
                onSubmit={onSubmit}
                {...props} />
        </Page>
    )
}

export default CreateOrganizationLocationPage;